import apiService from './api.service';

/** One page of notifications; always through the relative endpoint, never a server-built URL. */
const list = (page) => apiService.getNotifications(page ? { page } : {}).then((r) => r.data);

const markRead = (id) => apiService.markNotificationRead(id).then((r) => r.data);

const markAllRead = () => apiService.markAllNotificationsRead().then((r) => r.data);

const notificationsService = { list, markRead, markAllRead };

export default notificationsService;
